module.exports = __webpack_public_path__ + "img/no-video.398a2d7.png";